import React from 'react'
import EmptyLink from '@aytm/app/swidget/base/components/EmptyLink.tsx'
import Delivery from '../mobile/Delivery'
import PrimeToggle from '../components/PrimeToggle'
import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale.ts'
import style from './AppMobileHeader.module.scss'

interface IAppMobileHeaderProps {
  searchCondition: string
  clearSelection: () => void
  showCart: boolean
  selectedIndex: boolean
  onHomeClick: () => void
}

const AppMobileHeader = ({
  searchCondition,
  clearSelection,
  showCart,
  selectedIndex,
  onHomeClick
}: IAppMobileHeaderProps) => {
  const { t } = useSurveyLocale()

  return (
    <header className={style.Header}>
      <div className={style.Search}>
        {!showCart && !selectedIndex ? (
          <EmptyLink>
            <i className={`${style.Back} pi pi-arrow-left`}></i>
          </EmptyLink>
        ) : (
          <button className={style.BackActive} onClick={onHomeClick}>
            <i className={`${style.Back} pi pi-arrow-left`}></i>
          </button>
        )}
        <div className={style.Input}>
          <div className={style.InputSearch}>
            <EmptyLink>
              <i className="pi pi-search"></i>
            </EmptyLink>
          </div>
          <span className={style.Condition} onClick={clearSelection}>
            {searchCondition || t('questions', 'ec', 'amazon', 'searchAmazon')}
          </span>
          <div className={style.InputSearchScan}>
            <div className={style.InputSearchScanCenter}></div>
            <EmptyLink>
              <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 512 512">
                <path
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={65}
                  d="M342 444h46a56 56 0 0 0 56-56v-46m0-172v-46a56 56 0 0 0-56-56h-46M170 444h-46a56 56 0 0 1-56-56v-46m0-172v-46a56 56 0 0 1 56-56h46"
                ></path>
              </svg>
            </EmptyLink>
          </div>
          <div className={style.InputSearchMic}>
            <EmptyLink>
              <svg xmlns="http://www.w3.org/2000/svg" width="22px" height="22px" viewBox="0 0 24 24">
                <path
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2.4}
                  d="M9 6a3 3 0 0 1 3-3v0a3 3 0 0 1 3 3v5a3 3 0 0 1-3 3v0a3 3 0 0 1-3-3zm3 12a7 7 0 0 1-7-7v0v-1m7 8a7 7 0 0 0 7-7v0v-1m-7 8v3"
                ></path>
              </svg>
            </EmptyLink>
          </div>
        </div>
      </div>
      {!selectedIndex && !showCart && (
        <>
          <Delivery />
          <div className={style.Filter}>
            <div className={style.FilterButtons}>
              <EmptyLink>
                <div className={style.Filters}>{t('questions', 'ec', 'amazon', 'filters')}</div>
              </EmptyLink>
              <div className={style.Prime}>
                <PrimeToggle />
              </div>
            </div>
            <div className={style.FilterSlider}>
              <EmptyLink>
                <div className={style.FilterItem}>{t('questions', 'ec', 'amazon', 'purchased')}</div>
              </EmptyLink>
              <EmptyLink>
                <div className={style.FilterItem}>
                  <span className={style.Stars}></span> {t('questions', 'ec', 'amazon', 'aside11')}
                </div>
              </EmptyLink>
              <EmptyLink>
                <div className={style.FilterItem}>{t('questions', 'ec', 'amazon', 'aside13')}</div>
              </EmptyLink>
              <EmptyLink>
                <div
                  className={style.FilterItem}
                  dangerouslySetInnerHTML={{ __html: t('questions', 'ec', 'amazon', 'todayDeals') }}
                ></div>
              </EmptyLink>
              <EmptyLink>
                <div className={style.FilterItem}>{t('questions', 'ec', 'amazon', 'getFast')}</div>
              </EmptyLink>
              <EmptyLink>
                <div className={style.FilterItem}>{t('questions', 'ec', 'amazon', 'getTomorrow')}</div>
              </EmptyLink>
              <EmptyLink>
                <div className={style.FilterItem}>{t('questions', 'ec', 'amazon', 'overnight')}</div>
              </EmptyLink>
              <EmptyLink>
                <div className={style.FilterItem}>{t('questions', 'ec', 'amazon', 'spendLess')}</div>
              </EmptyLink>
              <EmptyLink>
                <div className={style.FilterItem}>{t('questions', 'ec', 'amazon', 'up25')}</div>
              </EmptyLink>
              <EmptyLink>
                <div className={style.FilterItem}>{t('questions', 'ec', 'amazon', 'to25')}</div>
              </EmptyLink>
              <EmptyLink>
                <div className={style.FilterItem}>{t('questions', 'ec', 'amazon', 'to50')}</div>
              </EmptyLink>
              <EmptyLink>
                <div className={style.FilterItem}>{t('questions', 'ec', 'amazon', 'to100')}</div>
              </EmptyLink>
              <EmptyLink>
                <div className={style.FilterItem}>{t('questions', 'ec', 'amazon', 'to200')}</div>
              </EmptyLink>
              <EmptyLink>
                <div className={style.FilterItem}>
                  {t('questions', 'ec', 'amazon', 'indoor')} <i className="pi pi-chevron-down"></i>
                </div>
              </EmptyLink>
              <EmptyLink>
                <div className={style.FilterItem}>{t('questions', 'ec', 'amazon', 'aside9')}</div>
              </EmptyLink>
              <EmptyLink>
                <div className={style.FilterItem}>
                  {t('questions', 'ec', 'amazon', 'recommend')} <i className="pi pi-chevron-down"></i>
                </div>
              </EmptyLink>
              <EmptyLink>
                <div className={style.FilterItem}>
                  {t('questions', 'ec', 'amazon', 'features')} <i className="pi pi-chevron-down"></i>
                </div>
              </EmptyLink>
              <EmptyLink>
                <div className={style.FilterItem}>
                  {t('questions', 'ec', 'amazon', 'shape')} <i className="pi pi-chevron-down"></i>
                </div>
              </EmptyLink>
              <EmptyLink>
                <div className={style.FilterItem}>
                  {t('questions', 'ec', 'amazon', 'aside6')} <i className="pi pi-chevron-down"></i>
                </div>
              </EmptyLink>
              <EmptyLink>
                <div className={style.FilterItem}>
                  {t('questions', 'ec', 'amazon', 'theme')} <i className="pi pi-chevron-down"></i>
                </div>
              </EmptyLink>
              <EmptyLink>
                <div className={style.FilterItem}>
                  {t('questions', 'ec', 'amazon', 'color')} <i className="pi pi-chevron-down"></i>
                </div>
              </EmptyLink>
            </div>
          </div>
        </>
      )}
    </header>
  )
}

export default AppMobileHeader
